// @flow

import { i18n } from 'shared/utils';

export default () => [
  {
    label: i18n.t('Entry # · Low to High'),
    value: { field: 'ENTRY_NUMBER', direction: 'ASC' },
  },
  {
    label: i18n.t('Entry # · High to Low'),
    value: { field: 'ENTRY_NUMBER', direction: 'DESC' },
  },
  {
    label: i18n.t('Date · Newest First'),
    value: { field: 'ENTRY_DATE', direction: 'DESC' },
  },
  {
    label: i18n.t('Date · Oldest First'),
    value: { field: 'ENTRY_DATE', direction: 'ASC' },
  },
  {
    label: i18n.t('Recently Updated'),
    value: { field: 'UPDATED_AT', direction: 'DESC' },
  },
  {
    label: i18n.t('Recently Created'),
    value: { field: 'CREATED_AT', direction: 'DESC' },
  },
];
